import { digObject } from '@domain-group/javascript-utils'

import useImages from '@hooks/useImages'
import useSelector from '@hooks/useSelector'

import useSelectEntities from '@hooks/useSelectEntities'

import { buildItemTitle } from '@functions/orderItem'

import type { CampaignModel, OrderItemModel } from '@models/types'

const imageIdsKeys = {
  Campaign: 'specified_portal_image_ids',
  OrderItem: 'specified_image_ids',
}

interface UseBulkSelectedIdsParams {
  entity: CampaignModel | OrderItemModel,
}

const useBulkSelectImages = (params: UseBulkSelectedIdsParams) => {
  const { entity } = params

  // @ts-expect-error TS2339
  const isCampaign = entity.type === 'Campaign'
  // @ts-expect-error TS2339
  const campaignId = isCampaign ? entity.id : entity.campaign_id

  // @ts-expect-error TS7053
  const imageIdsKey = imageIdsKeys[entity.type]
  const initSelectedImageIds = digObject(entity, `data.${imageIdsKey}`)

  const useSelectEntitiesPayload = useSelectEntities({ initSelectedIds: initSelectedImageIds })

  const {
    callbacks: {
      toggleId,
    },
    hasSelectedEntities,
    selectedEntityIds,
  } = useSelectEntitiesPayload

  const imagesPayload = useImages({
    filters: {
      hidden: 'false',
      imageable_id: campaignId,
      imageable_type: 'Campaign',
    },
    performHttpRequests: !!campaignId,
  })

  const { filteredImages, hasFilteredImages } = imagesPayload

  const imageIds = filteredImages.map(image => image.id)
  const deletedImageIds = selectedEntityIds.filter(selectedImageId => !imageIds.includes(selectedImageId))

  const updating = useSelector((reduxState) => {
    const { campaigns, orderItems } = reduxState
    return campaigns.updating || orderItems.updating
  })

  const sectionTitle = isCampaign ? 'Portal Images' : (buildItemTitle({ orderableItem: entity }) || '')

  return {
    callbacks: {
      selectId: (id: number) => toggleId(id),
    },
    deletedImageIds,
    filteredImages,
    hasFilteredImages,
    hasSelectedEntities,
    imageIdsKey,
    sectionTitle,
    selectedEntityIds,
    updating,
  }
}

export type UseBulkSelectImagesPayload = ReturnType<typeof useBulkSelectImages>

export default useBulkSelectImages
